import { Leaf } from "lucide-react";

export default function Marquee({ items, className = "" }) {
    const Track = ({ hidden }) => (
        <div className="marquee-track" aria-hidden={hidden || undefined}>
            {items.map((t, i) => (
                <span key={`${t}-${i}`} className="flex items-center">
                    <span className="whitespace-nowrap px-6 md:px-10 font-display text-base md:text-2xl font-bold tracking-wide">
                        {t}
                    </span>
                    <Leaf size={15} className="shrink-0 opacity-70" />
                </span>
            ))}
        </div>
    );

    return (
        <div className={`marquee-band overflow-hidden bg-leaf py-4 text-ink ${className}`} data-testid="marquee-band">
            <div className="flex">
                <Track />
                <Track hidden />
            </div>
        </div>
    );
}
